<template>
    <div class="ibox animated fadeInRightBig">
        <div>
            <div class="ibox-title" style="padding-top:5px; margin-bottom:-20px">
                <div class="row">
                    <div class="col-md-8 adjust-left offset-md-4" style="text-align: center;">
                        <h2 class="centered">Relatórios</h2>
                    </div>
                </div>
            </div>
            <div class="ibox-content">
                <div class="row mt-5">
                    <div class="col-md-4 adjust-left offset-md-3">
                        <label>Início</label>
                        <input v-model="filters.start" class="form-control" type="date"></input>
                    </div>
                    <div class="col-md-4 adjust-left">
                        <label>Término</label>
                        <input v-model="filters.end" class="form-control" type="date"></input>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-4 adjust-left offset-md-3">
                        <label><span class="required"></span> Área</label>
                        <v-select :options=teams label="name" v-model="teamId" :reduce="team => team.id">
                        </v-select>
                    </div>
                    <div class="col-md-4 adjust-left offset-md-3">
                        <label><span class="required"></span> Unidade</label>
                        <v-select :options=branches label="name" v-model="branchId" :reduce="branch => branch.id">
                        </v-select>
                    </div>

                </div>
                <div class="row mt-5">
                    <div class="col-md-8 adjust-left offset-md-3">
                        <table class="table">
                            <thead>
                                <tr class='centered'>
                                    <td>Conteúdo</td>
                                    <td>Ações</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="centered">
                                        <b>Participantes</b>
                                    </td>
                                    <td>
                                        <button class="btn btn-success btn-block"
                                            @click="extract('participansExtract/')">
                                            <i class="fa fa-download"></i> Baixar
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row centered" style="margin-left:45%" v-if="loading">
                    <span class="fa fa-spinner fa-spin fa-4x"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filters: {
                start: '',
                end: ''
            },
            teams: [],
            branches: [],
            teamId: '',
            branchId: '',
            loading: false,
        };
    },
    mounted() {
        this.getTeams();
        this.getBranches();
    },
    methods: {
        extract(extraction) {
            this.loading = true;
            const self = this;
            const api = self.$store.state.api + extraction;
            self.$http
                .post(api, {
                    start: self.filters.start.substring(0, 10),
                    end: self.filters.end.substring(0, 10),
                    team: self.teamId,
                    branch: self.branchId,
                })
                .then(response => {
                    window.open(
                        self.$store.getters.url +
                        "downloadExtractByHash/events/" +
                        response.data,
                        "_blank"
                    );
                    this.loading = false;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                    this.loading = false;
                });
        },
        getTeams: function () {
            let api = this.$store.state.api + 'teams?paginated=false';
            let self = this;

            self.$http.get(api)
                .then((response) => {
                    self.teams = response.data.data;
                    self.teams.push({ 'id': 'all', 'name': 'Todas as Áreas' })
                    self.teamId = 'all';
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, 'Ocorreu um erro ao carregar as informações', 'error');
                });
        },
        getBranches: function () {
            let api = this.$store.state.api + 'branches?paginated=false';
            let self = this;

            self.$http.get(api)
                .then((response) => {
                    self.branches = response.data.data;
                    self.branches.push({ 'id': 'all', 'name': 'Todas as Unidades' })
                    self.branchId = 'all';
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, 'Ocorreu um erro ao carregar as informações', 'error');
                });
        },
    }
};
</script>
<style>
.adjust-left {
    left: 15%;
    padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Reports/Reports.vue